import { render } from "./FormatGroupCreate.vue?vue&type=template&id=60de57a8"
import script from "./FormatGroupCreate.vue?vue&type=script&lang=js"
export * from "./FormatGroupCreate.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__